import React, { ChangeEvent, KeyboardEvent, useRef, useState } from 'react';

import styles from './PinInput.module.css';

interface PinInputProps {
  label?: string;
  required?: boolean;
  length: number;
  onChange: (values: string[]) => void;
}

export function PinInput({ label, length, onChange, required }: PinInputProps) {
  const [values, setValues] = useState<string[]>(Array(length).fill(''));
  const inputs = useRef<(HTMLInputElement | null)[]>([]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
    const value = e.target.value.toString();
    let val = value;
    if (value.length > 1) {
      val = value.toString()[value.length - 1];
    }

    if (/^[a-zA-Z0-9]$/.test(val)) {
      const newValues = [...values];
      newValues[index] = val;
      setValues(newValues);
      onChange(newValues);

      // Move to next input
      if (index < inputs.current.length - 1) {
        inputs.current[index + 1]?.focus();
      } else {
        inputs.current[index]?.blur();
      }
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace') {
      const newValues = [...values];
      newValues[index] = '';
      setValues(newValues);
      if (index > 0) {
        inputs.current[index - 1]?.focus();
      }
    }
  };
  return (
    /* eslint-disable no-return-assign */
    <div className={styles.pinInputWrap}>
      {label && (
        <span className={styles.pinInputLabel}>
          {label}
          {required && ' *'}
        </span>
      )}
      <div className={styles.pinInputContent}>
        {values.map((value, index) => (
          <input
            key={index.toString() + value}
            type="text"
            value={value}
            placeholder="&#9900;"
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={(el) => (inputs.current[index] = el)}
            className={styles.pinInputItem}
          />
        ))}
      </div>
    </div>
  );
}
